import { FolderResource } from 'src/app/models/resource/folder.resource';
import { FolderSdk } from 'src/app/sdks/folder.sdk';

export class FolderNode {
	isLoading = false;
	displayName: string;
	selected: boolean = false;
	isCaseRootNode: boolean = false;

	constructor(public folder: FolderResource, public level: number) {
		this.displayName = folder.folderName;
		this.isCaseRootNode = folder.isCaseRootNode;
	}

	get expandable(): boolean {
		// Leaf folders always have the right node = left node + 1.
		// If the difference between right and left is greater, it
		// indicates that the folder contains sub-folders.
		return this.folder.left + 1 < this.folder.right;
	}

	updateDocCount(folderService: FolderSdk) {
		folderService.getDocCount(this.folder.folderId).subscribe(data => {
			if (data > 0) {
				this.displayName = `${this.folder.folderName} (${data})`;
			}
		});
	}
}
